<template>
  <v-card-text>
    <GsaNavigator 
      :gsa_list="all_gsa"
    />
  </v-card-text>
</template>

<script>
import GsaNavigator from '../components/GsaNavigator.vue'
import {mapGetters} from 'vuex'


export default {
  computed:{
    ...mapGetters(['all_gsa'])
  },
  components:{
    GsaNavigator
  }
}
</script>